import * as React from "react";

/**
 * Custom warning icon
 *
 * @returns Custom warning icon
 */
const ValidationWarningIcon: React.FC = () => (
  <svg width="1em" height="1em">
    <path
      style={{
        fill: "#ffb901",
        fillOpacity: 1,
        fillRule: "evenodd",
      }}
      d="m53.991 48.099-16-.027 8.023-13.843Z"
      transform="translate(-37.991 -34.229)"
    />
    <path
      style={{
        fill: "#000",
        fillRule: "evenodd",
        strokeWidth: 0.0463858,
      }}
      d="M45.594 38.919h.861v5.423h-.861z"
      transform="translate(-37.991 -34.229)"
    />
    <path
      style={{
        fill: "#000",
        strokeWidth: 0.0467149,
      }}
      d="M45.594 45.293h.861v.861h-.861z"
      transform="translate(-37.991 -34.229)"
    />
  </svg>
);

export default ValidationWarningIcon;
